import {createAction, props} from '@ngrx/store';
import {AllScenariosState} from './scenarios.model';


export const getScenarios = createAction(
  '[ChangePage | ChangeTab | Delete] Get scenarios',
  props<AllScenariosState>()
);
